module.exports = __webpack_public_path__ + "img/wl_prod1_4.59c5bcba.jpg";